module.exports = __webpack_public_path__ + "img/tpc-25.6e55e99b.webp";